import {
    apiRequest,
    kriteriaSkpTunsusCreate
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunsusService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", kriteriaSkpTunsusCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository